<header class="row header">
  <h2>{{ 'EditModelProcesses' | translate }}</h2>

  <p-button (onClick)="onClose()" icon="pi pi-times" class="square mainAction" />

  <!-- <button (click)="onClose()" class="square mainAction">
    <span class="material-icons white text-white">close</span>
  </button> -->
</header>

<section class="content">
  <p>
    {{ 'ProcessesSetForAssetType' | translate }}
    <a>{{ model?.assetType?.name }}</a
    >. <br />
    {{ 'SelectCheckboxesForProcesses' | translate }} <br />
    {{ 'IfProcessSelectedChildSelected' | translate }} <br />
    {{ 'IfSubprocessSelectedParentSelected' | translate }}
  </p>

  <div class="row">
    <!-- <button (click)="openAll()" class="open-all-button">
      {{ 'OpenAll' | translate }}
    </button> -->
    <p-button (onClick)="closeAll()" class="close-all-button" [label]="'OpenAll' | translate" />
    <p-button (onClick)="closeAll()" class="close-all-button" [label]="'CloseAll' | translate" />
    <!-- <button (click)="closeAll()" class="close-all-button">
      {{ 'CloseAll' | translate }}
    </button> -->
  </div>

  <div *ngIf="model?.assetType?.assetProcesses?.length === 0" class="empty-message">
    <p>{{ 'NoProcessesAdded' | translate }} : {{ model?.assetType?.name }}</p>
  </div>

  <ul *ngFor="let process of model?.assetType?.assetProcesses" class="process-list">
    <li>
      <div class="process-header row">
        <button (click)="toggleProcess(process.id)" class="square" *ngIf="!!process.subProcesses.length">
          <span class="material-icons toggle-arrow">
            {{ showProcessesDict[process.id] ? 'expand_less' : 'expand_more' }}
          </span>
          <p-button [label]="showProcessesDict[process.id] ? 'expand_less' : 'expand_more'" />

          <p>{{ process.name }}</p>
          <p-checkbox [binary]="true" [ngModel]="!isProcessExcluded(process.id)" (onChange)="selectProcess(process.id)" />
        </button>
      </div>

      <div *ngIf="showProcessesDict[process.id]" class="subprocess-container">
        <ul class="subprocess-list">
          <li *ngFor="let subProcess of process.subProcesses">
            <div class="subprocess-header row">
              <button (click)="toggleProcess(subProcess.id)" class="square me-2" *ngIf="!!subProcess.subProcesses.length">
                <span class="material-icons toggle-arrow">
                  {{ showProcessesDict[subProcess.id] ? 'expand_less' : 'expand_more' }}
                </span>
              </button>

              <p>{{ subProcess.name }}</p>

              <p-checkbox [binary]="true" [ngModel]="!isProcessExcluded(subProcess.id)" (onChange)="selectProcess(subProcess.id)" />
            </div>

            <div *ngIf="showProcessesDict[subProcess.id]" class="nested-subprocess-container">
              <ul class="nested-subprocess-list">
                <li *ngFor="let nestedSubProcess of subProcess.subProcesses">
                  <div class="nested-subprocess-header row">
                    <p>{{ nestedSubProcess.name }}</p>

                    <!-- <input
                      type="checkbox"
                      (change)="selectProcess(nestedSubProcess.id)"
                      [checked]="!isProcessExcluded(nestedSubProcess.id)"
                    /> -->

                    <p-checkbox [binary]="true" [ngModel]="!isProcessExcluded(nestedSubProcess.id)" (onChange)="selectProcess(nestedSubProcess.id)" />
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</section>

<footer>
  <p-button class="w-full" (onClick)="onSave()" [label]="'Save' | translate" [disabled]="saving" />
  <p-button class="w-full" (onClick)="onClose()" [label]="'Cancel' | translate" [raised]="true" />
</footer>
